import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import './styles/tokens.css';
import './styles/app.css';

/**
 * Обновление установленного приложения.
 *
 * Служебный воркер ставит новую версию сам, но уже открытая страница
 * продолжает работать на старых файлах до перезагрузки. Выглядит это как
 * «задеплоили, а на телефоне всё по-старому», и лечится вручную — очень
 * плохо для приложения, которое живёт на домашнем экране.
 *
 * Поэтому страница перезагружается сама, но не в момент обновления, а
 * когда к ней возвращаются: перезагрузка посреди заполнения формы хуже
 * старой версии. Если вкладка в этот момент и так скрыта — сразу.
 */
if ('serviceWorker' in navigator) {
  // Было ли приложение под управлением воркера в момент загрузки: если нет,
  // то первое же controllerchange — это первая установка, а не обновление,
  // и перезагружать нечего.
  const wasControlled = Boolean(navigator.serviceWorker.controller);
  let pending = false;

  const applyUpdate = () => {
    if (!pending) return;
    pending = false;
    window.location.reload();
  };

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!wasControlled) return;
    pending = true;
    if (document.visibilityState === 'hidden') applyUpdate();
  });

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') applyUpdate();
  });
}

const root = document.getElementById('root');
if (!root) throw new Error('#root не найден в index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
